module.exports = __webpack_public_path__ + "img/TechInfantryArm2_ua.8f7dec43.webp";